module.exports = __webpack_public_path__ + "img/pdi_grey.c1fbbdc2.svg";